<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "disciplines",
    cardSetLink: "disciplines",
    item: null,
    fields: [
      {
        label: "Группа предметов",
        key: "category",
        type: "select",
        selectKey: "title",
        modal: "category",
        prefix: "category_pref",
      },
      {
        key: "title",
        label: "Название",
        type: "field",
        textType: "text",
        isMultiLang: true,
      },
      {
        col: 'col-6 col-md-4 col-lg-3',
        key: "icon",
        label: "Лого",
        type: "img",
        textType: "",
        MAX_WIDTH: '200',
        secondKey: 'color'
      },
      {
        col: 'col-12',
        key: "color",
        label: "Цвет фона",
        type: "field",
        textType: "color",
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
